document.addEventListener('DOMContentLoaded', () => {
  const swiperLogo = setSwiperLogo();

  new Zooming({
    bgColor: "rgb(0, 0, 0)",
    bgOpacity: 0.5,
    customSize: '100%',
    enableGrab: false,
    onOpen: (target) => {
      const div = target.parentElement;
      div.classList.add('zooming');
    },
    onClose: (target) => {
      const div = target.parentElement;
      div.classList.remove('zooming');
    },
  }).listen('.zoom');

  if(window.matchMedia('(max-width: 768px)').matches){
    setSwiperReason();
  }
  
  const uwb = new UWB({
    uaTabletViewport: {
      init: true,
      width: 1440,
    },
    toolSmoothScroll: {
      offsetSelector: '',
    },
  });

  const startFire = document.documentElement.clientHeight / 2;
  UWX.ScrollActionReferPosition('.page-top', startFire);
  
  UWX.ClickAction( '.problem-item', '--actived');

  UWX.ScrollActionReferElement('.cta-follow, .page-top', '.js-fire', {
    activeClass: '--actived', 
  });
});


const setSwiperReason = () => {
  return new Swiper('.js-slider-reason', {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides : true,
    autoplay: {
      delay: 10000,
    },
    navigation: {
      nextEl: '.swiper-btn-next',
      prevEl: '.swiper-btn-prev',
    },
  });
}

const setSwiperLogo = () => {
  return new Swiper('.sliderLogo', {
    loop: true,
    speed: 5000,
    slidesPerView: 'auto',
    spaceBetween: 0,
    direction: 'horizontal',
    freeMode: true,
    autoplay: {
      delay: 0,
      stopOnLast: false,
      disableOnInteraction: false,
    },
  });
}

$('.cover-btn').modalVideo({
  channel: 'custom',
  url: './assets/images/movie/mov-main.mp4'
});